import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: 'ICMMenuItem',
};

import { QItemProps } from 'quasar/dist/types';
import { ref } from 'vue';
import { ICMEventHub, exapndItem } from '../utils';
import type { ICMMenuExpandedComponent } from '../types';

/* Types Start */
interface propsType extends QItemProps {
  disabled?: boolean | undefined;
  autoClose?: boolean | undefined;
  unClickable?: boolean | undefined;
}
/* Types End */

/* Component Basic Start */

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    disabled: { type: [Boolean, null] },
    autoClose: { type: [Boolean, null] },
    unClickable: { type: [Boolean, null] }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  disabled?: boolean | undefined;
  autoClose?: boolean | undefined;
  unClickable?: boolean | undefined;
}

// @ts-ignore
// eslint-disable-next-line import/extensions, import/no-unresolved
const $this = ref<ICMMenuExpandedComponent>();

/* Component Basic End */

/* Data Start */
const hasHover = ref<boolean>(false);
const id = ICMEventHub.getId();
/* Data End */

/* Fucntions Start */
const handleMousehover = (): void => {
  hasHover.value = true;
  exapndItem($this.value);
};
const handleMouseleave = (): void => {
  hasHover.value = false;
  if (!props.disabled) ICMEventHub.$emit('submenuMouseleave');
};
/* Fucntions End */

expose({ id });

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, _mergeProps({
    ref_key: "$this",
    ref: $this,
    clickable: !__props.unClickable,
    "auto-close": "",
    class: "q-px-sm ICMMenu-q-item"
  }, _ctx.$attrs, {
    disabled: __props.disabled || undefined,
    disable: __props.disabled || undefined,
    onClick: _cache[0] || (_cache[0] = () => !__props.disabled && _unref(ICMEventHub).$emit('itemClick', [_unref(id)], __props.autoClose || true)),
    onMouseenter: handleMousehover,
    onMouseleave: handleMouseleave
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "postpend"),
      _createVNode(_component_q_item_section, { class: "q-pa-none" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }),
      _createVNode(_component_q_item_section, {
        class: "ICMMenu-q-item-prepend",
        side: ""
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "prepend")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16, ["clickable", "disabled", "disable"]))
}
}

})